import { useEffect } from 'react';
import { useThemePreference } from '@socialgoodsoftware/theme';
import { useOrganization } from '../contexts/OrganizationContext';
import { preferencesApi } from '../preferences-api';
import { featureQueryKey } from '../lib/api-client';

export function ThemeSync(): null {
  const { user } = useOrganization();
  const { setPreference } = useThemePreference();
  const preferencesQuery = preferencesApi.getPreferences.useQuery({
    queryKey: featureQueryKey('preferences'),
    enabled: Boolean(user),
    retry: false,
  });

  let savedTheme: string | undefined = undefined;
  if (user && preferencesQuery.data?.status === 200) {
    savedTheme = preferencesQuery.data.body.theme;
  }

  useEffect(() => {
    if (savedTheme !== undefined) {
      setPreference(savedTheme);
    }
  }, [savedTheme, setPreference]);

  return null;
}
